module.exports = __webpack_public_path__ + "media/images/redesign-images/careers/careers-student-main-05d3cc5eb085819c0f2df7f31aa626f6.jpg";